import { type ColorUnion, Tag } from '@factorialco/deprecated-design-system'

import type { PopoverMenuTouchableOptionProps as Option } from 'modules/core/components/PopoverMenu'
import Popover from 'modules/core/components/PopoverMenu'

export interface TagProps {
  label: string
  type?: ColorUnion
  showCircle?: boolean
  options?: Option[]
}

const TagComponent = ({
  label,
  type = Tag.Types.neutral,
  showCircle = false,
  options,
}: TagProps) => {
  const hasPopover = !!options?.length

  if (!hasPopover) {
    return (
      <Tag leftItem="circle" type={type} showCircle={showCircle}>
        {label}
      </Tag>
    )
  }

  return (
    <Popover type="list">
      <Popover.Trigger>
        <Tag
          leftItem="circle"
          rightItem="dropdown"
          type={type}
          showCircle={showCircle}
          showActionIcon
        >
          {label}
        </Tag>
      </Popover.Trigger>
      <Popover.Content side="bottom" align="start">
        {options.map((option) => (
          <Popover.TouchableOption
            key={option.title}
            onClick={option.onClick}
            title={option.title}
            description={option.description}
          />
        ))}
      </Popover.Content>
    </Popover>
  )
}

export default TagComponent
